export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/55b45af4-d909-4034-9105-9e9d4c3c26cd/images/a883739e9d34bb8c5ec5cee18179c7619a4dbc37ffff5cafea062586f677721e.jpeg",
  golf: "https://static.prod-images.emergentagent.com/jobs/55b45af4-d909-4034-9105-9e9d4c3c26cd/images/940969dd135750c5c77cf83f7e82c01dec28fd62ea5b25935727403b13a150d2.jpeg",
  night: "https://static.prod-images.emergentagent.com/jobs/55b45af4-d909-4034-9105-9e9d4c3c26cd/images/20588664a8296f396361332961d488d13d54e518a5bd1039e499165545ad832b.jpeg",
  pool: "https://static.prod-images.emergentagent.com/jobs/55b45af4-d909-4034-9105-9e9d4c3c26cd/images/07c82b2ae75e11184fe2bfc4e49828f2a55c97037cfac1e328efc769a9812230.jpeg",
  living: "https://static.prod-images.emergentagent.com/jobs/55b45af4-d909-4034-9105-9e9d4c3c26cd/images/dcccf8811e28a48f9d2a73957a949f5758cef9138d7da62c271cf93b9bac9631.jpeg",
  terrace: "https://static.prod-images.emergentagent.com/jobs/55b45af4-d909-4034-9105-9e9d4c3c26cd/images/a44f283876cb0d25982666ad3c89be6967a7b3925dd55b778305855e133d4e5b.jpeg",
  bedroom: "https://static.prod-images.emergentagent.com/jobs/55b45af4-d909-4034-9105-9e9d4c3c26cd/images/a849efa70568ab2fda2dc85ff94d7b3637f57251282814e8f9bc8501568485f9.jpeg",
  aerial: "https://static.prod-images.emergentagent.com/jobs/55b45af4-d909-4034-9105-9e9d4c3c26cd/images/a3fe67a32a17db0df2f6e21a213816cef581489c974689f4a24123f914d275fe.jpeg",
};

// Financial model — 5M flat × 17 ville (stime da validare)
export const FIN = {
  units: 17,
  price: 5,
  gdv: 85,
  costs: [
    { key: "land", it: "Terreno", en: "Land", ar: "الأرض", value: 5, validated: false },
    { key: "construction", it: "Costruzione e arredi", en: "Construction & furnishing", ar: "البناء والتأثيث", value: 17, validated: false },
    { key: "infra", it: "Urbanizzazione / infrastrutture", en: "Urbanization / infrastructure", ar: "البنية التحتية / أعمال التطوير", value: 2, validated: false },
    { key: "permits", it: "Oneri, permessi, progettazione, DL", en: "Fees, permits, design, works mgmt", ar: "رسوم وتصاريح وتصميم وإشراف", value: 1.5, validated: false },
    { key: "marketing", it: "Marketing + commissioni (4% GDV)", en: "Marketing + commissions (4% GDV)", ar: "تسويق + عمولات (4% GDV)", value: 3.4, validated: false },
    { key: "finance", it: "Costi finanziari", en: "Financial costs", ar: "تكاليف تمويلية", value: 2, validated: false },
    { key: "contingency", it: "Contingency (10%)", en: "Contingency (10%)", ar: "احتياطي طوارئ (10%)", value: 2.55, validated: false },
  ],
};
FIN.totalCost = Math.round(FIN.costs.reduce((s, c) => s + c.value, 0) * 100) / 100; // 33.45
FIN.profit = Math.round((FIN.gdv - FIN.totalCost) * 100) / 100; // 51.55
FIN.marginOnCost = Math.round((FIN.profit / FIN.totalCost) * 100); // 154
FIN.marginOnGdv = Math.round((FIN.profit / FIN.gdv) * 100); // 61

export const CASHFLOW = [
  { m: 0, v: 0 }, { m: 1, v: -5 }, { m: 2, v: -5.4 }, { m: 3, v: -6.5 },
  { m: 4, v: -7.6 }, { m: 5, v: -8.7 }, { m: 6, v: -9.2 }, { m: 7, v: -10.3 },
  { m: 8, v: -11.4 }, { m: 9, v: -12.2 }, { m: 10, v: -13.3 }, { m: 11, v: -14.2 },
  { m: 12, v: -15 }, { m: 13, v: -15.6 }, { m: 14, v: -16 }, { m: 15, v: -16.2 },
  { m: 16, v: -14.5 }, { m: 17, v: -12.5 }, { m: 18, v: -10 }, { m: 19, v: -7.5 },
  { m: 20, v: -4.5 }, { m: 21, v: -1 }, { m: 22, v: 3 }, { m: 23, v: 8 },
  { m: 24, v: 13 }, { m: 25, v: 19 }, { m: 26, v: 25 }, { m: 27, v: 31.5 },
  { m: 28, v: 38 }, { m: 29, v: 45 }, { m: 30, v: 51.6 },
];

export const sensitivityProfit = (price, land) => {
  const gdv = 17 * price;
  const marketing = 0.04 * gdv;
  const hardCosts = land + 17 + 2 + 1.5;
  const contingency = 0.1 * hardCosts;
  const total = hardCosts + marketing + 2 + contingency;
  return Math.round((gdv - total) * 10) / 10;
};

export const SENS_PRICES = [4.0, 4.5, 5.0, 5.5];
export const SENS_LAND = [4, 5, 6, 7];

export const CONTENT = {
  it: {
    nav: { investors: "Investitori", contact: "Contatti", pdf: "Scarica PDF" },
    marquee: "Is Molas · Sardegna · 17 Ville di Lusso · Golf 18+9 Buche · Vista Golf e Mare · 30 km da Cagliari",
    cover: {
      kicker: "Is Molas Golf Resort — Sardegna",
      title1: "Golf",
      titleAmp: "&",
      title2: "Sea",
      subtitle: "Diciassette ville di lusso tra il green e il Mediterraneo.",
      cta1: "Scopri il progetto",
      cta2: "Investment Case",
      scroll: "Scorri",
    },
    location: {
      no: "01",
      label: "Location",
      title: "Trenta chilometri da Cagliari.\nUn mondo a parte.",
      body: "Is Molas è uno dei resort golfistici storici del Mediterraneo, immerso nella macchia della Sardegna sud-occidentale. Un contesto già maturo — golf, hotel, clubhouse — a pochi minuti dalle spiagge più belle del sud dell'isola.",
      stats: [
        { v: "30 km", l: "da Cagliari e dall'aeroporto" },
        { v: "18+9", l: "buche di golf championship" },
        { v: "Hotel", l: "e clubhouse nel resort" },
        { v: "Sud-Ovest", l: "spiagge di Chia, Tuerredda, Pula" },
      ],
    },
    project: {
      no: "02",
      label: "Il Progetto",
      title: "17 ville, un solo linguaggio: pietra locale e linee contemporanee.",
      body: "Architettura contemporanea radicata nel paesaggio: facciate in pietra locale, volumi puri, vetrate a tutta altezza. Ogni villa è orientata per catturare la doppia vista — il green del golf e il mare all'orizzonte.",
      points: ["Architettura contemporanea firmata", "Facciate in pietra locale sarda", "Doppia vista: golf e mare", "Lotti generosi e privacy assoluta"],
    },
    lifestyle: {
      no: "03",
      label: "Lifestyle",
      title: "Vivere a cinque stelle, ogni giorno.",
      body: "Infinity pool privata, terrazze e pergolati per la vita all'aperto, interni con standard alberghiero cinque stelle e domotica integrata di ultima generazione.",
      items: [
        { t: "Infinity Pool", d: "15 × 3,5 m, a sfioro verso il golf" },
        { t: "Outdoor Living", d: "Terrazze e pergolati — 146 mq" },
        { t: "Interni 5 Stelle", d: "Materiali e finiture di prestigio" },
        { t: "Domotica", d: "Comfort, sicurezza ed efficienza integrate" },
      ],
    },
    villa: {
      no: "04",
      label: "La Villa Tipo",
      title: "Misure generose,\nproporzioni perfette.",
      body: "Ogni numero è pensato per una vita senza compromessi.",
      specs: [
        { v: "1.200–1.800", u: "mq", l: "Lotto" },
        { v: "218", u: "mq", l: "Superficie coperta" },
        { v: "490", u: "mq", l: "Superficie commerciale" },
        { v: "146", u: "mq", l: "Terrazze" },
        { v: "15 × 3,5", u: "m", l: "Piscina a sfioro" },
        { v: "800–1.300", u: "mq", l: "Giardino privato" },
      ],
    },
    custom: {
      no: "05",
      label: "Personalizzazione",
      title: "Ogni villa, un pezzo unico.",
      body: "Spazi, disposizioni, finiture e arredi di prestigio su misura: ogni proprietario definisce la propria villa insieme al team di progetto, dalla distribuzione degli ambienti alla selezione dei materiali.",
      note: "Ville personalizzabili in spazi, disposizioni, finiture e arredi di prestigio.",
      items: ["Layout e distribuzione degli spazi", "Finiture e materiali di pregio", "Arredi di prestigio su misura", "Integrazione domotica personalizzata"],
    },
    masterplan: {
      no: "06",
      label: "Masterplan",
      title: "2,5 ettari disegnati intorno alla privacy.",
      body: "La lottizzazione distribuisce 17 ville su 2,5 ettari, con lotti da 1.200 a 1.800 mq, viabilità privata e orientamenti studiati per garantire a ogni villa vista libera e riservatezza.",
      stats: [
        { v: "2,5 Ha", l: "superficie complessiva" },
        { v: "17", l: "lotti esclusivi" },
        { v: "100%", l: "ville con vista golf o mare" },
      ],
    },
    contact: {
      no: "07",
      label: "Contatti",
      title: "La tua villa a Is Molas inizia qui.",
      body: "Lascia i tuoi dati: il nostro team ti contatterà per una presentazione riservata del progetto e la disponibilità dei lotti.",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono (opzionale)",
      message: "Messaggio (opzionale)",
      submit: "Richiedi informazioni",
      sending: "Invio in corso…",
      success: "Grazie! Ti contatteremo a breve.",
      error: "Errore nell'invio. Riprova.",
    },
    gate: {
      no: "08",
      label: "Area Riservata",
      title: "Investment Case",
      body: "L'analisi economico-finanziaria del progetto è riservata a investitori qualificati. Inserisci la tua email e il codice di accesso ricevuto dal team.",
      email: "La tua email",
      code: "Codice di accesso",
      submit: "Sblocca l'Investment Case",
      checking: "Verifica in corso…",
      wrong: "Codice non valido. Contatta il team per l'accesso.",
      hint: "Non hai il codice? Richiedilo tramite il form contatti indicando \"Investitore\".",
    },
    invest: {
      label: "Investment Case — Riservato",
      title: "Un business case da 85 milioni.",
      disclaimer: "Tutti i valori non contrattualizzati sono stime da validare. Documento riservato, non costituisce offerta al pubblico né sollecitazione all'investimento.",
      kpis: [
        { v: "€85M", l: "Ricavi (GDV) — 17 × €5M" },
        { v: "€33,4M", l: "Costo totale progetto (stima)" },
        { v: "€51,6M", l: "Utile lordo di sviluppo (pre-imposte)" },
        { v: "154%", l: "Margine su costo" },
        { v: "61%", l: "Margine su GDV" },
        { v: "26–34 mesi", l: "Sviluppo e vendita — 6–8 ville/anno (scenario prudente)" },
      ],
      waterfallTitle: "Waterfall: dal GDV all'utile",
      waterfallNote: "Valori in €M. Costi aggiuntivi prudenziali — stime da validare.",
      cashflowTitle: "Cash flow cumulato — 30 mesi (scenario prudente)",
      cashflowNote: "Curva illustrativa sullo scenario prudente 6–8 ville/anno: esposizione massima ~€16M al mese 15, break-even al mese 22 con l'avanzare delle consegne, utile pieno a ~30 mesi. Da validare con piano vendite definitivo.",
      sensTitle: "Sensitivity: utile lordo (€M)",
      sensNote: "Le due leve critiche del piano: prezzo di vendita per villa e costo del terreno. Caso base evidenziato.",
      sensPrice: "Prezzo di vendita per villa (€M)",
      sensLand: "Costo terreno (€M)",
      riskTitle: "Assorbimento — un piano onesto",
      riskBody: "Il piano è costruito sullo scenario prudente: 6–8 ville vendute all'anno, con sold-out in 26–34 mesi. Un assorbimento più rapido resta possibile come upside, ma non è l'ipotesi su cui si fonda il business case.",
      riskScenarios: [
        { t: "Scenario prudente (base del piano)", d: "6–8 ville/anno — sold-out in 26–34 mesi, esposizione massima ~€16M, costi finanziari e di struttura prudenziali già inclusi, margine superiore al 50% su GDV." },
      ],
      taxNote: "Nota fiscale: imposte (IRES, IRAP, IMU) e IVA sono trattate separatamente e non incluse nell'utile lordo di sviluppo. Da quantificare con advisor fiscale in fase di strutturazione.",
      alignNote: "Nota di allineamento: il piano è allineato a 17 ville (il materiale originario indicava 16). Progetto architettonico: arch. Gabriele Rossi.",
      cta: "Vuoi il memorandum completo? Scrivici dal form contatti indicando \"Investitore\": sei già registrato come contatto qualificato.",
      estimate: "stima da validare",
    },
    footer: "Golf & Sea — Is Molas Golf Resort, Sardegna. Documento di presentazione: non costituisce offerta al pubblico.",
  },
  en: {
    nav: { investors: "Investors", contact: "Contact", pdf: "Download PDF" },
    marquee: "Is Molas · Sardinia · 17 Luxury Villas · 18+9 Hole Golf · Golf & Sea Views · 30 km from Cagliari",
    cover: {
      kicker: "Is Molas Golf Resort — Sardinia",
      title1: "Golf",
      titleAmp: "&",
      title2: "Sea",
      subtitle: "Seventeen luxury villas between the green and the Mediterranean.",
      cta1: "Discover the project",
      cta2: "Investment Case",
      scroll: "Scroll",
    },
    location: {
      no: "01",
      label: "Location",
      title: "Thirty kilometres from Cagliari.\nA world apart.",
      body: "Is Molas is one of the Mediterranean's historic golf resorts, set in the maquis of south-western Sardinia. A mature setting — golf, hotel, clubhouse — minutes from the island's most beautiful southern beaches.",
      stats: [
        { v: "30 km", l: "from Cagliari and the airport" },
        { v: "18+9", l: "championship golf holes" },
        { v: "Hotel", l: "and clubhouse within the resort" },
        { v: "South-West", l: "beaches of Chia, Tuerredda, Pula" },
      ],
    },
    project: {
      no: "02",
      label: "The Project",
      title: "17 villas, one language: local stone and contemporary lines.",
      body: "Contemporary architecture rooted in the landscape: local stone façades, pure volumes, full-height glazing. Every villa is oriented to capture the double view — the golf green and the sea on the horizon.",
      points: ["Signature contemporary architecture", "Local Sardinian stone façades", "Double view: golf and sea", "Generous plots and absolute privacy"],
    },
    lifestyle: {
      no: "03",
      label: "Lifestyle",
      title: "Five-star living, every day.",
      body: "Private infinity pool, terraces and pergolas for outdoor living, interiors built to five-star hotel standards, and fully integrated smart-home technology.",
      items: [
        { t: "Infinity Pool", d: "15 × 3.5 m, overflowing towards the golf" },
        { t: "Outdoor Living", d: "Terraces and pergolas — 146 sqm" },
        { t: "5-Star Interiors", d: "Prestige materials and finishes" },
        { t: "Smart Home", d: "Integrated comfort, security, efficiency" },
      ],
    },
    villa: {
      no: "04",
      label: "The Villa",
      title: "Generous measures,\nperfect proportions.",
      body: "Every number designed for uncompromising living.",
      specs: [
        { v: "1,200–1,800", u: "sqm", l: "Plot" },
        { v: "218", u: "sqm", l: "Covered area" },
        { v: "490", u: "sqm", l: "Commercial area" },
        { v: "146", u: "sqm", l: "Terraces" },
        { v: "15 × 3.5", u: "m", l: "Infinity pool" },
        { v: "800–1,300", u: "sqm", l: "Private garden" },
      ],
    },
    custom: {
      no: "05",
      label: "Customization",
      title: "Every villa, one of a kind.",
      body: "Bespoke spaces, layouts, finishes and prestige furnishings: each owner shapes their villa with the design team, from room distribution to material selection.",
      note: "Villas customizable in spaces, layouts, finishes and prestige furnishings.",
      items: ["Layout and space distribution", "Prestige finishes and materials", "Bespoke luxury furnishings", "Personalized smart-home integration"],
    },
    masterplan: {
      no: "06",
      label: "Masterplan",
      title: "2.5 hectares designed around privacy.",
      body: "The masterplan distributes 17 villas across 2.5 hectares, with plots from 1,200 to 1,800 sqm, private roads and orientations studied to give every villa open views and seclusion.",
      stats: [
        { v: "2.5 Ha", l: "total area" },
        { v: "17", l: "exclusive plots" },
        { v: "100%", l: "villas with golf or sea view" },
      ],
    },
    contact: {
      no: "07",
      label: "Contact",
      title: "Your villa at Is Molas starts here.",
      body: "Leave your details: our team will contact you for a private presentation of the project and plot availability.",
      name: "Full name",
      email: "Email",
      phone: "Phone (optional)",
      message: "Message (optional)",
      submit: "Request information",
      sending: "Sending…",
      success: "Thank you! We will be in touch shortly.",
      error: "Something went wrong. Please retry.",
    },
    gate: {
      no: "08",
      label: "Private Area",
      title: "Investment Case",
      body: "The project's financial analysis is reserved for qualified investors. Enter your email and the access code provided by the team.",
      email: "Your email",
      code: "Access code",
      submit: "Unlock the Investment Case",
      checking: "Verifying…",
      wrong: "Invalid code. Contact the team for access.",
      hint: "No code? Request it via the contact form mentioning \"Investor\".",
    },
    invest: {
      label: "Investment Case — Confidential",
      title: "An 85-million business case.",
      disclaimer: "All non-contracted figures are estimates to be validated. Confidential document — not a public offer nor a solicitation to invest.",
      kpis: [
        { v: "€85M", l: "Revenues (GDV) — 17 × €5M" },
        { v: "€33.4M", l: "Total project cost (estimate)" },
        { v: "€51.6M", l: "Gross development profit (pre-tax)" },
        { v: "154%", l: "Margin on cost" },
        { v: "61%", l: "Margin on GDV" },
        { v: "26–34 months", l: "Development & sales — 6–8 villas/year (prudent scenario)" },
      ],
      waterfallTitle: "Waterfall: from GDV to profit",
      waterfallNote: "Values in €M. Prudent additional costs — estimates to be validated.",
      cashflowTitle: "Cumulative cash flow — 30 months (prudent scenario)",
      cashflowNote: "Illustrative curve on the prudent 6–8 villas/year scenario: peak exposure ~€16M at month 15, break-even at month 22 as deliveries progress, full profit at ~30 months. To be validated with the final sales plan.",
      sensTitle: "Sensitivity: gross profit (€M)",
      sensNote: "The plan's two critical levers: sale price per villa and land cost. Base case highlighted.",
      sensPrice: "Sale price per villa (€M)",
      sensLand: "Land cost (€M)",
      riskTitle: "Absorption — an honest plan",
      riskBody: "The plan is built on the prudent scenario: 6–8 villas sold per year, with sold-out in 26–34 months. Faster absorption remains a possible upside, but it is not the assumption the business case relies on.",
      riskScenarios: [
        { t: "Prudent scenario (plan basis)", d: "6–8 villas/year — sold-out in 26–34 months, peak exposure ~€16M, prudent financial and overhead costs already included, margin above 50% on GDV." },
      ],
      taxNote: "Tax note: taxes (IRES, IRAP, IMU) and VAT are treated separately and not included in gross development profit. To be quantified with tax advisors during structuring.",
      alignNote: "Alignment note: the plan is aligned to 17 villas (original material stated 16). Architectural design: arch. Gabriele Rossi.",
      cta: "Want the full memorandum? Reach out via the contact form mentioning \"Investor\" — you are already registered as a qualified contact.",
      estimate: "estimate to be validated",
    },
    footer: "Golf & Sea — Is Molas Golf Resort, Sardinia. Presentation document: does not constitute a public offer.",
  },
  ar: {
    nav: { investors: "المستثمرون", contact: "اتصل بنا", pdf: "تحميل PDF" },
    marquee: "إس مولاس · سردينيا · 17 فيلا فاخرة · غولف 18+9 حفرة · إطلالة على الغولف والبحر · 30 كم من كالياري",
    cover: {
      kicker: "منتجع إس مولاس للغولف — سردينيا",
      title1: "Golf",
      titleAmp: "&",
      title2: "Sea",
      subtitle: "سبع عشرة فيلا فاخرة بين ملعب الغولف والبحر الأبيض المتوسط.",
      cta1: "اكتشف المشروع",
      cta2: "دراسة الاستثمار",
      scroll: "مرّر للأسفل",
    },
    location: {
      no: "01",
      label: "الموقع",
      title: "ثلاثون كيلومترًا من كالياري.\nعالمٌ آخر.",
      body: "إس مولاس هو أحد منتجعات الغولف العريقة في البحر الأبيض المتوسط، يقع وسط طبيعة جنوب غرب سردينيا الخلابة. بيئة متكاملة وناضجة — غولف وفندق ونادٍ — على بُعد دقائق من أجمل شواطئ جنوب الجزيرة.",
      stats: [
        { v: "30 كم", l: "من كالياري والمطار" },
        { v: "18+9", l: "حفرة غولف بمستوى البطولات" },
        { v: "فندق", l: "ونادٍ داخل المنتجع" },
        { v: "الجنوب الغربي", l: "شواطئ كيا وتويريدا وبولا" },
      ],
    },
    project: {
      no: "02",
      label: "المشروع",
      title: "17 فيلا بلغة معمارية واحدة: حجر محلي وخطوط معاصرة.",
      body: "عمارة معاصرة متجذرة في المشهد الطبيعي: واجهات من الحجر المحلي، كتل نقية، وواجهات زجاجية بكامل الارتفاع. كل فيلا موجهة لالتقاط الإطلالة المزدوجة — خُضرة ملعب الغولف والبحر في الأفق.",
      points: ["عمارة معاصرة بتوقيع مميز", "واجهات من الحجر السرديني المحلي", "إطلالة مزدوجة: الغولف والبحر", "قطع أراضٍ واسعة وخصوصية تامة"],
    },
    lifestyle: {
      no: "03",
      label: "نمط الحياة",
      title: "حياة بمستوى خمس نجوم، كل يوم.",
      body: "مسبح إنفينيتي خاص، تراسات وبرجولات للحياة في الهواء الطلق، تشطيبات داخلية بمعايير الفنادق الفاخرة، وأنظمة منزل ذكي متكاملة من أحدث جيل.",
      items: [
        { t: "مسبح إنفينيتي", d: "15 × 3.5 م، منسابٌ نحو ملعب الغولف" },
        { t: "حياة خارجية", d: "تراسات وبرجولات — 146 م²" },
        { t: "تشطيبات 5 نجوم", d: "خامات وتشطيبات فاخرة" },
        { t: "منزل ذكي", d: "راحة وأمان وكفاءة متكاملة" },
      ],
    },
    villa: {
      no: "04",
      label: "الفيلا النموذجية",
      title: "مساحات سخية،\nونِسَب مثالية.",
      body: "كل رقم مصمم لحياة بلا تنازلات.",
      specs: [
        { v: "1,200–1,800", u: "م²", l: "قطعة الأرض" },
        { v: "218", u: "م²", l: "المساحة المبنية" },
        { v: "490", u: "م²", l: "المساحة التجارية" },
        { v: "146", u: "م²", l: "التراسات" },
        { v: "15 × 3.5", u: "م", l: "مسبح إنفينيتي" },
        { v: "800–1,300", u: "م²", l: "حديقة خاصة" },
      ],
    },
    custom: {
      no: "05",
      label: "التخصيص",
      title: "كل فيلا، قطعة فريدة.",
      body: "مساحات وتوزيعات وتشطيبات وأثاث فاخر حسب الطلب: كل مالك يصوغ فيلته مع فريق التصميم، من توزيع الغرف إلى اختيار الخامات.",
      note: "فلل قابلة للتخصيص في المساحات والتوزيعات والتشطيبات والأثاث الفاخر.",
      items: ["تخطيط وتوزيع المساحات", "تشطيبات وخامات فاخرة", "أثاث فاخر حسب الطلب", "أنظمة منزل ذكي مخصصة"],
    },
    masterplan: {
      no: "06",
      label: "المخطط العام",
      title: "2.5 هكتار مصممة حول الخصوصية.",
      body: "يوزع المخطط العام 17 فيلا على 2.5 هكتار، بقطع أراضٍ من 1,200 إلى 1,800 م²، مع طرق خاصة وتوجيهات مدروسة تضمن لكل فيلا إطلالة مفتوحة وخصوصية تامة.",
      stats: [
        { v: "2.5 هكتار", l: "المساحة الإجمالية" },
        { v: "17", l: "قطعة أرض حصرية" },
        { v: "100%", l: "فلل بإطلالة على الغولف أو البحر" },
      ],
    },
    contact: {
      no: "07",
      label: "اتصل بنا",
      title: "فيلتك في إس مولاس تبدأ من هنا.",
      body: "اترك بياناتك وسيتواصل معك فريقنا لتقديم عرض خاص للمشروع وتوافر قطع الأراضي.",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "الهاتف (اختياري)",
      message: "رسالة (اختياري)",
      submit: "اطلب المعلومات",
      sending: "جارٍ الإرسال…",
      success: "شكرًا لك! سنتواصل معك قريبًا.",
      error: "حدث خطأ في الإرسال. حاول مرة أخرى.",
    },
    gate: {
      no: "08",
      label: "منطقة خاصة",
      title: "دراسة الاستثمار",
      body: "التحليل المالي للمشروع مخصص للمستثمرين المؤهلين. أدخل بريدك الإلكتروني ورمز الدخول الذي حصلت عليه من الفريق.",
      email: "بريدك الإلكتروني",
      code: "رمز الدخول",
      submit: "افتح دراسة الاستثمار",
      checking: "جارٍ التحقق…",
      wrong: "رمز غير صالح. تواصل مع الفريق للحصول على حق الدخول.",
      hint: "ليس لديك الرمز؟ اطلبه عبر نموذج التواصل مع الإشارة إلى \"مستثمر\".",
    },
    invest: {
      label: "دراسة الاستثمار — سرّي",
      title: "دراسة أعمال بقيمة 85 مليونًا.",
      disclaimer: "جميع القيم غير المتعاقد عليها هي تقديرات قيد التحقق. وثيقة سرية — لا تشكل عرضًا عامًا ولا دعوة للاستثمار.",
      kpis: [
        { v: "€85M", l: "الإيرادات (GDV) — 17 × €5M" },
        { v: "€33.4M", l: "التكلفة الإجمالية للمشروع (تقدير)" },
        { v: "€51.6M", l: "إجمالي ربح التطوير (قبل الضرائب)" },
        { v: "154%", l: "الهامش على التكلفة" },
        { v: "61%", l: "الهامش على GDV" },
        { v: "26–34 شهرًا", l: "التطوير والبيع — 6–8 فلل سنويًا (سيناريو متحفظ)" },
      ],
      waterfallTitle: "الشلال: من الإيرادات إلى الربح",
      waterfallNote: "القيم بملايين اليورو. تكاليف إضافية متحفظة — تقديرات قيد التحقق.",
      cashflowTitle: "التدفق النقدي التراكمي — 30 شهرًا (سيناريو متحفظ)",
      cashflowNote: "منحنى توضيحي وفق السيناريو المتحفظ 6–8 فلل سنويًا: ذروة الانكشاف ~€16M في الشهر 15، نقطة التعادل في الشهر 22 مع تقدم التسليمات، والربح الكامل عند ~30 شهرًا. قيد التحقق مع خطة المبيعات النهائية.",
      sensTitle: "تحليل الحساسية: إجمالي الربح (€M)",
      sensNote: "الرافعتان الحرجتان للخطة: سعر بيع الفيلا وتكلفة الأرض. الحالة الأساسية مميزة.",
      sensPrice: "سعر البيع لكل فيلا (€M)",
      sensLand: "تكلفة الأرض (€M)",
      riskTitle: "الاستيعاب — خطة صادقة",
      riskBody: "الخطة مبنية على السيناريو المتحفظ: بيع 6–8 فلل سنويًا، مع اكتمال البيع خلال 26–34 شهرًا. يبقى الاستيعاب الأسرع احتمالًا إيجابيًا، لكنه ليس الفرضية التي تقوم عليها دراسة الجدوى.",
      riskScenarios: [
        { t: "السيناريو المتحفظ (أساس الخطة)", d: "6–8 فلل سنويًا — اكتمال البيع في 26–34 شهرًا، ذروة انكشاف ~€16M، تكاليف مالية وإدارية متحفظة مشمولة، وهامش يتجاوز 50% على GDV." },
      ],
      taxNote: "ملاحظة ضريبية: الضرائب (IRES وIRAP وIMU) وضريبة القيمة المضافة تُعالج بشكل منفصل وغير مشمولة في إجمالي ربح التطوير. تُحدد كميًا مع مستشار ضريبي في مرحلة الهيكلة.",
      alignNote: "ملاحظة مواءمة: الخطة مواءمة على 17 فيلا (المواد الأصلية ذكرت 16). التصميم المعماري: المهندس غابرييلي روسي.",
      cta: "هل تريد المذكرة الكاملة؟ راسلنا عبر نموذج التواصل مع الإشارة إلى \"مستثمر\" — أنت مسجل بالفعل كجهة اتصال مؤهلة.",
      estimate: "تقدير قيد التحقق",
    },
    footer: "Golf & Sea — منتجع إس مولاس للغولف، سردينيا. وثيقة عرض: لا تشكل عرضًا عامًا.",
  },
};
